import { html } from 'lit'
import HedeliusBaseItem from '../base-item.js'

customElements.define(
    'hedelius-left-item-default',
    class HedeliusLeftItemDefault extends HedeliusBaseItem {
        static properties = {
            isActive: { type: Boolean, reflect: true },
        }

        renderAnchor() {
            return html`
                <li
                    class="${this.isActive
                        ? 'md:border-black'
                        : ''} flex flex-1 border-b-[2px] border-white transition-all"
                >
                    ${this.node.children.length > 0
                        ? html` <button
                              @click="${(e) => this._handleClick(e, this.node)}"
                              class="${this.isActive
                                  ? 'md:!font-black'
                                  : ''} flex flex-1 items-center justify-between text-left text-2xl font-light leading-none hover:font-medium md:text-xl"
                          >
                              <span class="py-8"> ${this.node.title} </span>
                              <svg
                                  class="mr-5 h-6 w-6 md:hidden"
                                  xmlns="http://www.w3.org/2000/svg"
                                  stroke="black"
                                  fill="none"
                                  viewBox="0 0 12.74 22.24"
                              >
                                  <g>
                                      <polyline
                                          class="cls-1"
                                          points=".71 .71 11.33 11.33 1.12 21.54"
                                      />
                                  </g>
                              </svg>
                          </button>`
                        : html`
                        <a
                            @click="${(e) => this._handleClick(e, this.node)}"
                            class="flex flex-1 md:text-xl text-2xl items-center justify-between leading-none font-light hover:font-medium ${
                                this.isActive ? 'md:!font-black' : ''
                            }"
                            href="${this.node.href}"
                        >
                            <span class="py-8"> ${this.node.title} </span>
                            <svg
                                class="md:hidden h-6 w-6 mr-5"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="black"
                                fill="none"
                                viewBox="0 0 12.74 22.24"
                            >
                                <g>
                                    <polyline class="cls-1" points=".71 .71 11.33 11.33 1.12 21.54" />
                                </g>
                            </svg>
                        </a>
                    </li>
                `}
                </li>
            `
        }
    }
)
